import styled from 'styled-components';

import { StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

export const TradeContainer = styled.div<{ isTradeExpand?: boolean }>`
    ${({ theme: { colors, breakpoints }, isTradeExpand }) => `
        min-height: ${isTradeExpand ? `100vh` : `100%`};
        height: ${isTradeExpand ? `100vh` : `100%`};
        width: 100%;
        border-right: 1px solid ${colors.border.light};
        @media (max-width: ${breakpoints.md}) {
            min-width: 100%;
            min-height: 318px;
            width: 100%;
            height: 50vh;
            border-right: 0;
        }
    `};
`;

export const ListHeader = styled(StyledFlexContainer)<{ isTradeExpand?: boolean }>`
    ${({ theme: { typography, breakpoints, colors }, isTradeExpand }) => `
        display: none;
        ${
            !isTradeExpand
                ? `@media (min-width: ${breakpoints.xxl}) {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        padding: 12px 22px;
                        border-bottom: 1px solid ${colors.border.light};
                        & > span {
                            font-size: ${typography.size.desktop.paragraph.p2};
                            line-height: calc(${typography.lineHeight[3]} - 0.5px);
                            font-weight: ${typography.weight.medium};
                        }
                    }`
                : ``
        }
        @media (max-width: ${breakpoints.md}) {
            display: block;
            padding: 16px 16px 8px 16px;
            & > span {
                font-size: ${typography.size.mobile.paragraph.p1};
                line-height: ${typography.lineHeight[4]};
                font-weight: ${typography.weight.semiBold};
                letter-spacing: -0.02em;
            }
        }
    `};
`;

export const ListTitle = styled(StyledFlexContainer)`
    justify-content: space-between;
    padding: 9px 12px;
    width: 100%;
    ${({ theme: { colors, typography, breakpoints } }) => `
        & > span {
            color: ${colors.text.tertiary};
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            letter-spacing: -0.02em;
        }
        & > span {
            &:nth-of-type(1) {
                width: 32%;
            }
            &:nth-of-type(2) {
                width: 35%;
                text-align: center;
            }
            &:nth-of-type(3) {
                width: 33%;
                text-align: end;
            }
        }
        @media (max-width: ${breakpoints.md}) {
            padding: 0px 16px 8px 16px;
            & > span {
                line-height: ${typography.lineHeight[3]};
            }
        }
    `};
`;
export const ListItemContainer = styled.div<{ isTradeExpand?: boolean }>`
    ${({ theme: { breakpoints }, isTradeExpand }) => `
        overflow-y: hidden;
        height: ${isTradeExpand ? `calc(100% - 33px)` : `calc(100% - 73px)`};
        @media (max-width: ${breakpoints.md}) {
            min-height: calc(50vh - 70px);
            overflow-y: auto;
        }
        @media (min-width: ${breakpoints.xxl}) {
            height: ${isTradeExpand ? 'calc(100% - 33px)' : `calc(100% - 76.5px)`};
        }
    `};
`;
export const ListItem = styled(StyledFlexContainer)`
    justify-content: space-between;
    padding: 5px 12px 8px;
    width: 100%;
    ${({ theme: { colors, typography, breakpoints } }) => `
        @media (min-height: ${breakpoints.xl}) {
            padding: 4.85px 16px 7.85px 19px;
        }
        & > span {
            color: ${colors.text.primary};
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            letter-spacing: -0.02em;
            &:nth-of-type(1) {
                width: 32%;
            }
            &:nth-of-type(2) {
                width: 35%;
                text-align: center;
            }
            &:nth-of-type(3) {
                width: 33%;
                text-align: end;
            }
        }
        @media (max-width: ${breakpoints.md}) {
            padding: 0px 12px 8px 16px;
            & > span {
                line-height: ${typography.lineHeight[2]};
            }
        }
    `};
`;
